import {useAppSelector} from "@Hooks/selector/useAppSelector";
import {ExperimentsType} from "@/types/Experiments.type";

export default function useExperiments() {
    const {experimentsJson} = useAppSelector((state) => state?.page);

    return experimentsJson as ExperimentsType;
}